@if (toastService.toasts().length) {
  <div class="fixed top-4 left-0 right-0 z-[10000] flex flex-col gap-2 pointer-events-none">
    @for (toast of toastService.toasts(); track toast.id) {
      <div class="w-full flex justify-center {{ positionClass(toast.position) }}">
        <!-- Móvil: ancho completo. Desde xs: card alineada al lado indicado. -->
        <div class="w-full xs:w-auto xs:max-w-xl mx-4 pointer-events-auto">
          <div
            class="flex items-center min-h-[56px] p-4 gap-3 rounded-[16px] shadow-lg"
            [style.background-color]="style(toast.type).bg"
            role="status"
            aria-live="polite"
          >
            <i class="fi {{ style(toast.type).icon }} text-xl leading-none shrink-0" [style.color]="style(toast.type).color"></i>

            <span class="flex-1 whitespace-pre-line break-words text-text-primary text-base font-medium leading-5">
              {{ toast.message }}
            </span>

            @if (toast.action; as action) {
              <button
                type="button"
                (click)="runAction(toast.id, action)"
                class="shrink-0 min-h-[44px] min-w-[44px] px-2 py-1 rounded-lg text-base font-semibold underline"
                [style.color]="style(toast.type).color"
              >
                {{ action.label }}
              </button>
            }

            <button
              type="button"
              (click)="remove(toast.id)"
              title="Cerrar"
              aria-label="Cerrar"
              class="flex items-center justify-center min-h-[44px] min-w-[44px] shrink-0 rounded-full hover:bg-black/5 transition-colors"
            >
              <i class="fi fi-ss-cross text-[10px] leading-none"></i>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}
